<template>
  <div>
    <template v-if="!iframeTokenValid">

    <zt-menu-bar v-if="render" permanent :list-options="isMenuCompleted" @click:profile="handlerClickProfile"
      @menu-update="handleMenuBarExpand">
    </zt-menu-bar>
    <zt-menu-bar v-else permanent :list-options="menuManagerCompleted" @click:profile="handlerClickProfile"
      @menu-update="handleMenuBarExpand">
    </zt-menu-bar>
    </template>

    <!-- Los tabs están ocultos en modo iframe -->
    
    <zt-off-canvas :max-width="isMobile ? '100%' : '300px'" :active="isOffCanvasActive" @close="closeOffCanvas">
      <div>
        <div v-if="!isMobile" class="custom-header flex justify-between items-center p-4">
          <a @click="closeOffCanvas" class="flex flex-none items-center justify-center button-back">
            <zt-icon name="arrow-left" class="mr-2" />
            <span>Sichern Way</span>
          </a>
          <a v-if="isShowAdminLink" href="https://pas.sichern.com.ar/" target="_blank" rel="noopener noreferrer"
            class="flex flex-none items-center anchor-admin">
            <span>{{ $t('message.menuComponent.managerAd') }}</span>
            <zt-icon name="external-link" class="ml-2 external-link" />
          </a>
        </div>
        <div v-if="isMobile" class="custom-header flex justify-center items-center mb-4 p-4 bg-back">
          <button @click="closeOffCanvas" class="absolute">
            <zt-icon name="angle-left" class="mr-2" />
          </button>
          <h5>{{ $t('message.menuComponent.myApps') }}</h5>
        </div>
        <div class="off-canvas-body p-4">
          <a v-if="isMobile && isShowAdminLink" href="https://pas.sichern.com.ar/" target="_blank" rel="noopener noreferrer"
            class="flex flex-none items-center anchor-admin mb-4 ml-2">
            <span>{{ $t('message.menuComponent.managerAd') }}</span>
            <zt-icon name="external-link" class="ml-2 external-link" />
          </a>

          <a v-if="showApplication('SABA')" class="flex items-center p-2 application-link"
            :class="{ 'no-ml': isMobile }" @click.prevent="redirectToApp('SABA')">
            <i class="app-icon mr-4">
              <svg version="1.1" id="svg2" xml:space="preserve" x="0px" y="0px" viewBox="0 0 177.60506 198.4704"
                sodipodi:docname="78b5673377f49bfb967752ce6d4a0c5a-04.pdf"
                xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
                xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns="http://www.w3.org/2000/svg"
                xmlns:svg="http://www.w3.org/2000/svg">
                <defs id="defs6">
                  <clipPath clipPathUnits="userSpaceOnUse" id="clipPath16">
                    <path d="M 0,148.853 H 133.204 V 0 H 0 Z" id="path14" />
                  </clipPath>
                </defs>
                <sodipodi:namedview id="namedview4" pagecolor="#ffffff" bordercolor="#666666" borderopacity="1.0"
                  inkscape:pageshadow="2" inkscape:pageopacity="0.0" inkscape:pagecheckerboard="0" />
                <g id="g8" inkscape:groupmode="layer" inkscape:label="78b5673377f49bfb967752ce6d4a0c5a-04"
                  transform="matrix(1.3333333,0,0,-1.3333333,0,198.4704)">
                  <g id="g10">
                    <g id="g12" clip-path="url(#clipPath16)">
                      <g id="g18" transform="translate(66.602,109.2985)">
                        <path
                          d="M 0,0 -36.875,21.442 -56.53,10.071 C -62.703,6.335 -66.602,-0.325 -66.602,-7.473 V -29.89 l 7.635,-4.385 z"
                          style="fill:#73c175;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path20" />
                      </g>
                      <g id="g22" transform="translate(125.5688,75.0231)">
                        <path
                          d="m 0,0 7.635,4.548 v 22.255 c 0,7.147 -3.899,13.807 -10.072,17.382 L -22.062,55.576 -58.967,34.275 Z"
                          style="fill:#73c175;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path24" />
                      </g>
                      <g id="g26" transform="translate(133.2035,70.4743)">
                        <path d="M 0,0 V 9.097 L -7.635,4.549 Z"
                          style="fill:#51b45f;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path28" />
                      </g>
                      <g id="g30" transform="translate(7.6347,75.0231)">
                        <path d="M 0,0 58.967,-34.275 117.934,0 58.967,34.275 Z"
                          style="fill:#51b45f;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path32" />
                      </g>
                      <g id="g34" transform="translate(103.5072,130.5993)">
                        <path
                          d="m 0,0 -26.834,15.573 c -6.173,3.574 -13.97,3.574 -20.143,0 L -73.78,0.142 -36.905,-21.301 Z"
                          style="fill:#83c780;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path36" />
                      </g>
                      <g id="g38" transform="translate(29.831,19.4323)">
                        <path
                          d="m 0,0 26.699,-15.397 c 6.173,-3.574 13.97,-3.574 20.143,0 L 73.396,-0.078 36.771,21.315 Z"
                          style="fill:#2f9145;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path40" />
                      </g>
                      <g id="g42" transform="translate(-1e-4,79.4089)">
                        <path d="m 0,0 v -8.935 l 7.635,4.549 z"
                          style="fill:#51b45f;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path44" />
                      </g>
                      <g id="g46" transform="translate(7.6347,75.0231)">
                        <path
                          d="m 0,0 -7.635,-4.549 v -22.255 c 0,-7.147 3.899,-13.807 10.072,-17.381 l 19.759,-11.406 36.771,21.316 z m 117.934,0 -58.967,-34.275 36.626,-21.394 19.905,11.321 c 6.172,3.737 10.071,10.397 10.071,17.544 v 22.255 z"
                          style="fill:#3da550;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path48" />
                      </g>
                      <g id="g50" transform="translate(123.1322,32.4626)">
                        <path
                          d="m 0,0 -46.459,-26.966 c -6.173,-3.573 -13.97,-3.573 -20.143,0 L -113.061,0 c -6.172,3.574 -10.071,10.234 -10.071,17.382 v -1.625 c 0,-7.148 3.899,-13.808 10.071,-17.381 l 46.459,-26.804 c 6.173,-3.573 13.97,-3.573 20.143,0 L 0,-1.624 C 6.173,1.949 10.071,8.609 10.071,15.757 v 1.625 C 10.071,10.234 6.173,3.574 0,0"
                          style="fill:#2f9145;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path52" />
                      </g>
                      <g id="g54" transform="translate(67.5014,93.3874)" />
                      <g id="g56" transform="translate(66.602,1.2927)">
                        <path
                          d="m 0,0 c 9.516,0 17.23,-0.29 17.23,-0.646 0,-0.357 -7.714,-0.647 -17.23,-0.647 -9.517,0 -17.231,0.29 -17.231,0.647 C -17.231,-0.29 -9.517,0 0,0"
                          style="fill:#d1d1d1;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path58" />
                      </g>
                      <g id="g60" transform="translate(104.7846,84.0944)">
                        <path
                          d="m 0,0 c -0.506,1.558 -1.888,2.661 -3.516,2.808 l -22.202,2.016 -8.775,20.542 c -0.648,1.51 -2.122,2.485 -3.762,2.485 -1.641,0 -3.116,-0.975 -3.76,-2.485 L -50.789,4.824 -72.995,2.808 C -74.623,2.658 -76.001,1.555 -76.511,0 c -0.506,-1.557 -0.038,-3.265 1.193,-4.345 l 16.783,-14.717 -4.948,-21.794 c -0.362,-1.603 0.259,-3.26 1.589,-4.221 0.715,-0.52 1.555,-0.778 2.397,-0.778 0.725,0 1.449,0.191 2.096,0.579 l 19.146,11.447 19.141,-11.447 c 1.405,-0.839 3.17,-0.763 4.497,0.199 1.33,0.961 1.952,2.618 1.59,4.221 l -4.949,21.794 16.784,14.717 C 0.038,-3.265 0.506,-1.56 0,0"
                          style="fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path62" />
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </i>
            <span>Sichern Talent</span>
          </a>
          <a v-if="showApplication('SICHERN_UNITE')" class="flex items-center p-2 application-link"
            :class="{ 'no-ml': isMobile }" @click.prevent="redirectToApp('SICHERN_UNITE')">
            <i class="app-icon mr-4">
              <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 40 40"
                style="enable-background:new 0 0 40 40;" xml:space="preserve">
                <g>
                  <path fill="#0B7AC0" d="M13.57,13.39c-0.81,0-1.47-0.66-1.47-1.48v-0.86c0-1.49-1.21-2.71-2.7-2.71c-1.57,0-2.79,1.21-2.79,2.71v0.86
		c0,0.82-0.66,1.48-1.47,1.48c-0.81,0-1.47-0.66-1.47-1.48v-0.86c0-3.12,2.53-5.66,5.65-5.66c3.2,0,5.73,2.54,5.73,5.66v0.86
		C15.04,12.73,14.38,13.39,13.57,13.39" />
                  <path fill="#0B7AC0" d="M34.87,13.39c-0.81,0-1.47-0.66-1.47-1.48v-0.86c0-1.49-1.21-2.71-2.7-2.71c-1.57,0-2.79,1.21-2.79,2.71v0.86
		c0,0.82-0.66,1.48-1.47,1.48c-0.81,0-1.47-0.66-1.47-1.48v-0.86c0-3.12,2.53-5.66,5.65-5.66c3.2,0,5.73,2.54,5.73,5.66v0.86
		C36.34,12.73,35.68,13.39,34.87,13.39" />
                  <path fill="#0B7AC0" d="M9.87,15.1c1.93,0,3.49,1.61,3.49,3.6v2.1c0,3.64,2.87,6.6,6.39,6.6c3.72,0,6.59-2.96,6.59-6.6v-2.1
		c0-1.99,1.56-3.6,3.49-3.6c1.93,0,3.49,1.61,3.49,3.6v2.1c0,7.61-6,13.81-13.37,13.81c-7.57,0-13.57-6.19-13.57-13.81v-2.1
		C6.39,16.71,7.95,15.1,9.87,15.1" />
                </g>
              </svg>
            </i>
            <span>Sichern Unite</span>
          </a>
          <a v-if="showApplication('GEOVICTORIA')" class="flex items-center p-2 application-link"
            :class="{ 'no-ml': isMobile }" @click.prevent="redirectToApp('GEOVICTORIA')">
            <i class="app-icon mr-4">
              <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 256.7 286.9"
                style="enable-background:new 0 0 256.7 286.9;" xml:space="preserve">
                <g>
                  <g>
                    <g>
                      <path class="st0"
                        d="M128.3,76.2L57.3,34.9L19.4,56.8C7.5,64,0,76.9,0,90.6v43.2l14.7,8.5L128.3,76.2z"
                        fill="#F48E7D" />
                      <path class="st0"
                        d="M242,142.3l14.7-8.8V90.6c0-13.8-7.5-26.6-19.4-33.5l-37.8-22l-71.1,41L242,142.3z"
                        fill="#F48E7D" />
                      <path class="st1" d="M256.7,151v-17.5l-14.7,8.8L256.7,151z" fill="#F37D62" />
                      <path class="st1" d="M14.7,142.3l113.6,66.1L242,142.3L128.3,76.2L14.7,142.3z" fill="#F37D62" />
                      <path class="st2"
                        d="M199.5,35.2l-51.7-30c-11.9-6.9-26.9-6.9-38.8,0L57.3,34.9l71.1,41.3L199.5,35.2z"
                        fill="#F69C90" />
                      <path class="st3"
                        d="M57.5,249.4l51.5,29.7c11.9,6.9,26.9,6.9,38.8,0l51.2-29.5l-70.6-41.2L57.5,249.4z"
                        fill="#E56445" />
                      <path class="st1" d="M0,133.8V151l14.7-8.8L0,133.8z" fill="#F37D62" />
                      <path class="st4" d="M242,142.3l-113.6,66.1l70.6,41.2l38.4-21.8c11.9-7.2,19.4-20,19.4-33.8V151L242,142.3z M14.7,142.3L0,151
              				v42.9c0,13.8,7.5,26.6,19.4,33.5l38.1,22l70.9-41.1L14.7,142.3z" fill="#F37752" />
                      <path id="Self-shadow_1_" class="st3" d="M237.3,224.3l-89.5,52c-11.9,6.9-26.9,6.9-38.8,0l-89.5-52C7.5,217.4,0,204.6,0,190.8
              				v3.1c0,13.8,7.5,26.6,19.4,33.5l89.5,51.7c11.9,6.9,26.9,6.9,38.8,0l89.5-51.7c11.9-6.9,19.4-19.7,19.4-33.5v-3.1
              				C256.7,204.6,249.2,217.4,237.3,224.3z" fill="#E56445" />
                    </g>
                  </g>
                  <g id="Shadow_3_">
                    <ellipse class="st5" cx="128.3" cy="285.6" rx="33.2" ry="1.2" fill="#D1D1D1" />
                  </g>
                  <g>
                    <path class="st6" d="M128.6,71.2c-39.2,0-71,31.8-71,71s31.8,71,71,71s71-31.8,71-71S167.8,71.2,128.6,71.2L128.6,71.2z
              			 M174.5,148.2h-45.9c-3.3,0-5.9-2.7-5.9-5.9V96.4c0-3.3,2.6-5.9,5.9-5.9c3.3,0,5.9,2.7,5.9,5.9v40h40c3.3,0,5.9,2.7,5.9,5.9
              			C180.4,145.5,177.7,148.2,174.5,148.2L174.5,148.2z M174.5,148.2" fill="#FFFFFF" />
                  </g>
                </g>
              </svg>
            </i>
            <span>Sichern Time</span>
          </a>
        </div>
      </div>
    </zt-off-canvas>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import i18n from '@/plugins/i18n'
import {
  filter,
  isEmpty,
  orderBy,
  includes,
  map,
  some,
  has,
  uniq
} from 'lodash'
import { menuActionsModel, managerActionsModel } from '../../models/optionsMenu'
import { useWindowResize } from '@sichern/ui-elements'
import { useMutationMenuBar } from './hooks/useMenuBar'
import { storeOffCanvas, storeMutationOffCanvas } from './hooks/offcanvas'
import Users from '@/apiClient/Users'

const getAvailableOptions = opts =>
  filter(menuActionsModel, opt => includes(opts, opt.id))

const getManagerAvailableOptions = opts =>
  filter(managerActionsModel, opt => includes(opts, opt.id))
export default {
  name: 'ZtMenu',
  inject: ['store'],
  data() {
    return {
      options: [],
      windowResize: useWindowResize(this),
      applications: [],
      user: new Users(),
      isManager: false,
      isManagerRole: this.$store.state.isManagerRole,
      isForceUpdate: 0,
      badgeUpdateInProgress: false,
    }
  },
  computed: {
    ...mapState(['actions']),
    ...mapGetters(['isUserActive', 'getUser']),
    render() {
      return !this.isManager || !this.changeRole;
    },
    isMenuCompleted() {
      if (isEmpty(this.actions)) {
        return []
      }

      if (!this.isUserActive) {
        return getAvailableOptions(['0', '27'])
      }

      let actionsIds = map(this.actions, 'id')
      const profiles = this.getUser.perfiles
      let isHr = false
      let isApprover = false
      if (!actionsIds.includes('0')) {
        actionsIds.push('0')
      }
      profiles.forEach(profile => {
        if (profile.id_perfil_tipo === 2 || profile.id_perfil_tipo === 7) {
          actionsIds.push('op')
          isHr = true
        }
        if (profile.id_perfil_tipo === 5) {
          isApprover = true
        }
      })
      if (this.$store.state.payrollStatus && !actionsIds.includes('payroll')) {
        actionsIds.push('payroll');
      }
      
      if (actionsIds.includes('71') && actionsIds.includes('72')) {
        actionsIds = uniq(actionsIds)
        let index
        if (isHr && !isApprover) {
          index = actionsIds.indexOf('71')
        } else {
          index = actionsIds.indexOf('72')
        }
        actionsIds.splice(index, 1)
      }
      const options = orderBy(getAvailableOptions(actionsIds), 'id', 'asc');
      const index = options.findIndex(item => item.id === '0');
      if (index > -1) {
        const [itemWithId0] = options.splice(index, 1); 
        options.unshift(itemWithId0); 
      }
      const menuItems = this.isManager ? 
      [{ name: this.$t('message.settingsComponent.myAccount').toUpperCase(), icon: 'minus' }, ...options,{ name:  this.$t('message.settingsComponent.manager'), icon: 'minus' }] : options;
      return menuItems
    },
    menuManagerCompleted() {
      const excludedActions = this.isMenuCompleted.filter(item1 => !managerActionsModel.some(item2 => item2.name === item1.name));
      const actionsIdsManager = [...this.actions.map(item => item.id), '0'];
      const optionsManager = getManagerAvailableOptions(actionsIdsManager);
      const desktop = [...excludedActions, ...optionsManager];
      
      if (this.iframeTokenValid) {
        return desktop;
      }
      return !!this.isManagerRole && this.isMobile ? optionsManager : desktop
    },

    isOffCanvasActive() {
      return storeOffCanvas.active
    },
    isMobile() {
      return this.windowResize.width < 1024
    },
    isShowAdminLink() {
      return this.isMenuCompleted.filter(obj => obj.id === 'op').length > 0
    },
    showApplicationSABA() {
      return (
        some(
          this.actions,
          action => action.id === '100' || action.id === '101' || action.id === '102'
        ) && this.getUser.estado_empresa === 1
      )
    },
    locale() {
      return this.$store.getters.getLocale
    },
    changeRole() {
      return this.$store.getters.getIsManagerRole
    },
    iframeTokenValid() {
      return this.$iframeMessages.isTokenValid()
    },
    performanceSourceUrlData() {
      return this.$iframeMessages.performanceSourceUrlData()
    },
  },
  async created() {
    // await this.$store.dispatch('setPayrollStatus')
    this.isManager = this.$store.state.user.perfiles.some(objeto => objeto.id_perfil_tipo === 8);
    if (this.showApplicationSABA) {
      const applicationsResponse = await this.user.applicationsSAML()
      this.applications = applicationsResponse.data.data
    }
    if (this.isManager) {
      this.$store.dispatch('setManagerTasksPending')
    }
  },
  mounted() {
    this.setupExternalLinkHandler()
    
    window.addEventListener('resize', () => {
      this.closeOffCanvas()
    })
    
    this.$watch(
      () => this.$store.state.managerTasksPending,
      (newCount) => {
        this.updateTaskManagerBadge(newCount)
      },
      { immediate: true }
    )
  },
  beforeDestroy() {
    if (this.handleExternalLinkClick) {
      document.removeEventListener('click', this.handleExternalLinkClick, true)
    }
  },
  methods: {
    ...useMutationMenuBar,
    setupExternalLinkHandler() {
      this.handleExternalLinkClick = (event) => {
        const target = event.target
        const menuItem = target.closest('.zt-menu-bar--list-options')
        if (menuItem) {
          const allMenuItems = document.querySelectorAll('.zt-menu-bar--list-options')
          const itemIndex = Array.from(allMenuItems).indexOf(menuItem)
          if (itemIndex >= 0) {
            const menuOptions = this.render ? this.isMenuCompleted : this.menuManagerCompleted
            const clickedOption = menuOptions[itemIndex]
            if (clickedOption && clickedOption.url && clickedOption.url === 'https://pas.sichern.com.ar') {
              event.preventDefault()
              event.stopPropagation()
              event.stopImmediatePropagation()
              const newWindow = window.open(clickedOption.url, '_blank', 'noopener,noreferrer')
              if (newWindow) {
                newWindow.opener = null
              }
            }
          }
        }
      }
      document.addEventListener('click', this.handleExternalLinkClick, true)
    },
    updateTaskManagerBadge(count) {
      if (this.badgeUpdateInProgress) {
        return
      }

      this.badgeUpdateInProgress = true
      
      const updateBadge = () => {
        const taskIcon = document.querySelector('.zt-menu-bar--list-options a em i.zt-icon-clipboard-task')
        
        if (!taskIcon) {
          return false
        }

        const emElement = taskIcon.closest('em')
        
        if (!emElement) {
          this.badgeUpdateInProgress = false
          return false
        }
        
        let badge = emElement.querySelector('.menu-task-badge')
        
        if (count > 0) {
          if (!badge) {
            badge = document.createElement('span')
            badge.className = 'menu-task-badge'
            emElement.appendChild(badge)
          }
          badge.textContent = count > 99 ? '99+' : count;
        }

        if (badge && count === 0) {
          badge.remove()
        }
        
        this.badgeUpdateInProgress = false
        
        return true
      }

      this.$nextTick(() => {
        if (updateBadge()) {
          return
        }
        
        const observer = new MutationObserver(() => {
          if (updateBadge()) {
            observer.disconnect()
          }
        })
        
        observer.observe(document.body, {
          childList: true,
          subtree: true
        })
        
        setTimeout(() => {
          observer.disconnect()
          this.badgeUpdateInProgress = false
        }, 5000)
      })
    },
    handlerClickProfile(event) {
      this.store.ref._onClick(event)
    },
    handleMenuBarExpand(val) {
      this.setMenuBarStyles(val)
      this.iconsClass(val.width)
    },
    openOffCanvas() {
      storeMutationOffCanvas.setOffCanvasActive(true)
    },
    closeOffCanvas() {
      storeMutationOffCanvas.setOffCanvasActive(false)
    },
    redirectToApp(app) {
      const urlApp = this.applications[app]
      window.open(urlApp, '_blank')
    },
    showApplication(app) {
      return has(this.applications, app)
    },
    iconsClass(width) {
      const divs = document.querySelectorAll("div > a > em > i.zt-icon-minus");
  divs.forEach((divIcon) => {
    const div = divIcon.closest("div");
    div.classList.add("divider-text");
    div.style.pointerEvents = "none";
    const emElement = div.querySelector("a > em");
    emElement.classList.toggle("em-divider-text", width === '270px');
  });
    },
    navigateToTab(routeName) {
    if (routeName && this.$route.name !== routeName) {
      this.$router.push({ name: routeName });
    }
  },
},
  watch: {
    locale() {
      i18n.locale = this.locale
      menuActionsModel.forEach((item, index) => {
        if (item.id == "72" || item.id == "71") {
          menuActionsModel[index].shortName = this.$t('message.menuComponent.licences.shortName')
          menuActionsModel[index].name = this.$t('message.menuComponent.licences.name')
          this.isForceUpdate = this.isForceUpdate + 1
        }
      })
      this.$forceUpdate()
    },
    changeRole() {
      this.$forceUpdate()
    }
  }
  
}
</script>

<style scoped lang="scss">
::v-deep .zt-menu-bar--list {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

::v-deep .zt-menu-bar--list::-webkit-scrollbar {
  width: 0px;
}

.zt-menu-bar--list-options a {
  line-height: 1;
}

.zt-menu-bar--list-options em {
  height: 64px;
  width: 84px;
}

.zt-menu-bar--list-options em i {
  font-size: 1.5rem;
}

.button-back,
.anchor-admin {
  line-height: 1;
}

.button-back {
  font-weight: bold;
  color: #2d2d2d;
  font-size: 1.3rem;

  i {
    font-size: 1.8rem;
  }
}

.anchor-admin {
  color: #0d57c9;
}

.application-link {
  margin-left: 25px;
  border-radius: 5px;
  color: #2d2d2d;

  .app-icon {
    width: 40px;
    height: 40px;
    background: #f1f1f1;
    border-radius: 5px;
  }

  &:hover {
    background: #e7e7e7;
  }
}

.application-link.no-ml {
  margin-left: 0;
}

.external-link {
  font-size: 0.8rem;
  line-height: 1;
}

.bg-back {
  background: #2d2d2d;

  button {
    left: 1rem;
  }

  button,
  h5 {
    color: #ffffff;
    font-size: 1.063rem;
  }
}

::v-deep .bg-zt-primary-200 {
  background-color: var(--branding-primary, var(--v-primary-base));

}

::v-deep .divider-text:last-child{
  height: 35px !important;
}

::v-deep .text-white {
  color: var(--branding-textColor, white);

}

::v-deep .zt-menu-bar--list-options:hover {

  background-color: var(--branding-secondary, var(--v-primary-lighten5)) !important;

}

::v-deep .zt-menu-bar--list-options .router-link-exact-active {
  background-color: var(--branding-activeColor, var(--v-primary-lighten2)) !important; //item activo 
}

::v-deep .divider-text .router-link-exact-active {
  background-color: var(--branding-primary, var(--v-primary-base)) !important;
}

::v-deep .divider-text {
  pointer-events: none;
}

::v-deep .em-divider-text {
  width: 45px !important;
}


::v-deep div.zt-menu-bar--list-options>a>em>i.zt-icon-minus {
  transform: scale(3, 0.5);
  pointer-events: none;
}

::v-deep .divider-text>a>span {
  font-size: 12px !important;
}

::v-deep .em-divider-text>i.zt-icon-minus {
  transform: scale(1, 0.5) !important;
  pointer-events: none;
}

::v-deep div.zt-menu-bar--list {
  overflow-y: auto
}

::v-deep div:has(> a > em > i.zt-icon-minus) {
  pointer-events: none !important;
}

/* Badge para el gestor de tareas */
::v-deep .menu-task-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  background-color: #bd1c1c;
  color: white;
  border-radius: 50%;
  font-size: 10px;
  font-weight: 600;
  font-style: normal;
  line-height: 1;
  position: absolute;
  top: 8px;
  left: 50%;
  box-sizing: border-box;
}

/* Asegurar que el contenedor <em> sea relativo para el posicionamiento del badge */
::v-deep .zt-menu-bar--list-options a em {
  position: relative;
}
</style>
